import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Employee, PermissionType } from '../../shared/models/employee/employees.model';
import { AtlasAppId } from '../../shared/models/employee/employee-permissions-type.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EmployeeService {
  private baseUrl = environment.baseUrl + 'employees/';

  constructor(private http: HttpClient) { }

  public getEmployee = (id: string) => this.http.get<Employee[]>(`${this.baseUrl}?fields=uid,username&filter=username=LOWER('${id}')&includePermissions=true`);

  public getEmployees = () => this.http.get<Employee[]>(`${this.baseUrl}?fields=uid,firstName,lastName,preferredName,employeeNumber,username&filter=uid!=null AND employeeStatusCode!='T' AND employeeStatusCode!='R'&count=5000`);

  public getEmployeePermissions = (uid: string) => this.http.get<Employee[]>(`${this.baseUrl}?fields=uid&filter=uid='${uid}'&includePermissions=true`);

  public getPermissionTypes = () => this.http.get<PermissionType[]>(`${this.baseUrl}permission/types?appId=${AtlasAppId}`);

  public saveEmployeePermissions = (uid: string, permissions: string[]) => this.http.post<Employee>(this.baseUrl, { id: uid, appId: AtlasAppId, permissions: permissions });
}
